import * as prismic from '@prismicio/client';
import { GraphQLClient } from 'graphql-request';
import { client as prismicClient } from '../contexts/prismic-provider';

export const prismicGraphQLClient = new GraphQLClient(prismic.getGraphQLEndpoint('nobank'), {
  jsonSerializer: JSON,
  fetch: prismicClient.graphQLFetch,
  method: 'get',
});
